// extracted by mini-css-extract-plugin
module.exports = {"UpdateBtn":"UpdateBtn_UpdateBtn__3UUdo","Transparent":"UpdateBtn_Transparent__2it5I"};